import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function MobileDeviceIcon(props) {
  return (
    <SvgIcon viewBox="0 0 14 22" title="Mobile Device" {...props}>
      <path d="M11.25 0H3.25C1.87 0 0.75 1.12 0.75 2.5V19.5C0.75 20.88 1.87 22 3.25 22H11.25C12.63 22 13.75 20.88 13.75 19.5V2.5C13.75 1.12 12.63 0 11.25 0ZM7.25 21C6.42 21 5.75 20.33 5.75 19.5C5.75 18.67 6.42 18 7.25 18C8.08 18 8.75 18.67 8.75 19.5C8.75 20.33 8.08 21 7.25 21ZM11.75 17H2.75V3H11.75V17Z" />
    </SvgIcon>
  );
}

export default MobileDeviceIcon;
